// extracted by mini-css-extract-plugin
export var meta = "blog-post-module--meta--sQxBo";
export var article = "blog-post-module--article--37Yl2";
export var container = "blog-post-module--container--3ptyV";
export var articleNavigation = "blog-post-module--articleNavigation--196l1";